import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import 'normalize.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './index.css';
import { queryClient } from './queryClient';

const isSentryEnabled = true; // TODO import.meta.env.VITE_SENTRY_ENABLED === 'true';

if (isSentryEnabled) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    release: import.meta.env.BUILD_TIMESTAMP,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.feedbackIntegration({
        lang: 'hu',
        // Additional SDK configuration goes in here, for example:
        colorScheme: 'system',
      }),
    ],
    tracesSampleRate: 1.0,
  });
} else {
  // eslint-disable-next-line
  console.info("[Sentry] Not initialized: VITE_SENTRY_ENABLED is not 'true'.");
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
